import {
  InlineError$PunishAfterEditing,
  InlineError$PunishBeforeSubmitting,
  InlineError$PunishWhileEditing,
} from "@/modules/form-field/errors";
import { useField$Text } from "@/modules/form-field/hooks/useField$Text";

type Params = {
  initialMintPrice: number | undefined;
};

function textToValue(text: string): number {
  text = text.replace(/[\s,]/g, ""); // preprocessing: remove all spaces, and commas (thousand separator)

  if (!text) {
    throw new InlineError$PunishBeforeSubmitting("This field is required");
  }

  if (text.includes("-")) {
    throw new InlineError$PunishWhileEditing("Negative value is not allowed");
  }

  if (/[^0-9.]/.test(text)) {
    throw new InlineError$PunishWhileEditing(
      "Input contains invalid characters"
    );
  }

  const matched = /^([0-9]*)(\.)?([0-9]*)$/.exec(text);
  if (!matched) {
    // probably input contains more than one dot
    throw new InlineError$PunishAfterEditing("Invalid number");
  }

  const integerPart = matched[1];
  const decimalPart = matched[3];

  if (decimalPart.length > 6) {
    throw new InlineError$PunishAfterEditing(
      "The decimal part must not contain more than 6 digits"
    );
  }

  const value = Number(integerPart + decimalPart.padEnd(6, "0"));

  if (value < 0) {
    throw new InlineError$PunishAfterEditing("Cannot be less than 0 ADA");
  }

  if (value > 1e12) {
    throw new InlineError$PunishAfterEditing("Cannot be more than 1000000 ADA");
  }

  return value;
}

export function valueToText(value: number): string {
  InlineError$PunishWhileEditing.assert(
    value >= 0,
    "Negative value is not allowed"
  );
  const integerPart = Math.floor(value / 1000000).toString();
  const decimalPart = (value % 1000000)
    .toString()
    .padStart(6, "0")
    .replace(/0*$/, "");
  return decimalPart ? integerPart + "." + decimalPart : integerPart;
}

export const useFieldMintPrice = useField$Text.withConfig<number, Params>({
  getInitialText: ({ initialMintPrice }) =>
    initialMintPrice != null ? valueToText(initialMintPrice) : "",
  textToValue,
  valueToText,
});
